<template>
  <Dialog header="Columns" :visible="visible" :modal="true" :style="{ width: '360px' }" class="p-fluid" @update:visible="$emit('update:visible', $event)">
    <div v-for="c in columns" :key="c.field" class="p-field-checkbox">
      <Checkbox :id="'pseCol_' + c.field" :value="c.field" :modelValue="value" @input="$emit('input', $event)" :disabled="c.fixed" />
      <label :for="'pseCol_' + c.field">{{ c.header }}</label>
    </div>
  </Dialog>
</template>

<script>
// Design B: the cog button's column chooser, a plain list of the grid's columns (the Enquiries grid's own chooser is
// driven by db views, which the shared enquiry grids do not have).
export default {
  name: 'GridColumns',
  props: {
    visible: { type: Boolean, default: false },
    // [{field, header, fixed}]
    columns: { type: Array, required: true },
    // the chosen fields
    value: { type: Array, required: true }
  }
}
</script>
